import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const DeleteIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.25 5A2.75 2.75 0 0 1 11 2.25h2A2.75 2.75 0 0 1 15.75 5H18a1 1 0 0 1 1 1v1H5V6a1 1 0 0 1 1-1zm1.5 0h4.5c0-.69-.56-1.25-1.25-1.25h-2c-.69 0-1.25.56-1.25 1.25M6 8h12v11a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2zm2.25 2v8.5h1.5V10zm3 0v8.5h1.5V10zm3 0v8.5h1.5V10z"
      clipRule="evenodd"
    />
  </BaseIcon>
)
